import Tag, { type TagProps } from '@cobliteam/ui/components/Tag';

import DeviceLostDataIcon from '../../../icons/device-status-indicators/device-lost-data-icon.svg?react';
import DeviceNewIcon from '../../../icons/device-status-indicators/device-new-icon.svg?react';

const LostData = (props: TagProps) => {
  return <Tag {...props} label={props.label || 'Perdendo dados'} variant='contained' color='danger' icon={<DeviceLostDataIcon data-testid='tag-device-new-icon' />} />;
};

const New = (props: TagProps) => {
  return <Tag {...props} label={props.label || 'Novo dispositivo'} variant='contained' color='success' icon={<DeviceNewIcon data-testid='tag-lost-data-icon' />} />;
};

export default {
  New,
  LostData,
};
